import { render, staticRenderFns } from "./baseProduct.vue?vue&type=template&id=3d939da5&scoped=true&"
import script from "./baseProduct.vue?vue&type=script&lang=js&"
export * from "./baseProduct.vue?vue&type=script&lang=js&"
import style0 from "./baseProduct.vue?vue&type=style&index=0&id=3d939da5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d939da5",
  null
  
)

export default component.exports